import { FC } from 'react';
import styles from './notFound.module.scss';
import { observer } from 'mobx-react-lite';

const NotFound: FC = observer(() => {
  return (
    <div className={styles.main}>
      <h3>Sorry no data</h3>
    </div>
  );
});

export default NotFound;
